module.exports = __webpack_public_path__ + "media/images/logo/fakturaonline-square-logo-cs-748774744474a0d05e9f2168039cbd9f.svg";